import { createSlice } from "@reduxjs/toolkit";
import { discoverTabs } from "../../utils/constants";
const initialState = {
    total: 0,
    search: "",
    discoverData: [],
    filter_beds: [],
    filter_baths: [],
    construction_status: null,
    city: null,
    municipality: null,
    district: null,
    property_type: null,
    status: null,
    discoverLoading: false,
    page: {
        pageSize: 12,
        currentPage: 1,
    },
    isFilterModalOpen: false,
    isMapPropertyModalOpen: false,
    isClusterPropertyListOpen: false,
    activeTab: discoverTabs[0].key,
    mapBound: null,
    mapZoom: null,
    clusterPropertyData: [],
};

export const discoverSlice = createSlice({
    name: "discover",
    initialState,
    reducers: {
        setPage: (state, { payload }) => {
            return {
                ...state,
                page: {
                    ...state.page,
                    currentPage: payload,
                },
            };
        },
        setFilter: (state, { payload }) => {
            const {
                construction_status,
                search,
                filter_beds,
                filter_baths,
                property_type,
                city,
                district,
                municipality,
                property_for,
                status,
            } = payload;
            return {
                ...state,
                ...("search" in payload && { search }),
                ...("construction_status" in payload && {
                    construction_status,
                }),
                ...("city" in payload && { city }),
                ...("municipality" in payload && { municipality }),
                ...("district" in payload && { district }),
                ...("property_type" in payload && { property_type }),
                ...("status" in payload && { status }),
                ...("property_for" in payload && { property_for }),
                ...("filter_beds" in payload && { filter_beds }),
                ...("filter_baths" in payload && { filter_baths }),
                page: {
                    ...state.page,
                    currentPage: 1,
                },
            };
        },
        setDiscoverData: (state, { payload }) => {
            const { total, data } = payload;
            return {
                ...state,
                total,
                discoverData: data,
            };
        },
        handleDiscoverLoading: (state, { payload }) => {
            return {
                ...state,
                discoverLoading: payload,
            };
        },
        setActiveTab: (state, { payload }) => {
            return {
                ...state,
                activeTab: payload,
            };
        },
        toggleDiscoverModal: (state, { payload }) => {
            const {
                isFilterModalOpen,
                isMapPropertyModalOpen,
                isClusterPropertyListOpen,
            } = payload;

            return {
                ...state,
                ...("isFilterModalOpen" in payload && { isFilterModalOpen }),
                ...("isMapPropertyModalOpen" in payload && {
                    isMapPropertyModalOpen,
                }),
                ...("isClusterPropertyListOpen" in payload && {
                    isClusterPropertyListOpen,
                }),
            };
        },
        mapViewChanged: (state, { payload }) => {
            const { mapZoom, mapBound } = payload;

            return {
                ...state,
                ...("mapZoom" in payload && { mapZoom }),
                ...("mapBound" in payload && { mapBound }),
            };
        },
        filterForClusterData: (state, { payload = [] }) => {
            const ids = new Set(payload);
            state.clusterPropertyData = (state.discoverData || []).filter(
                ({ id }) => id != null && ids.has(id)
            );
        },
        resetFilter: () => {
            return initialState;
        },
        resetSearchFilter: (state) => {
            return {
                ...state,
                search: "",
                construction_status: "",
                city: "",
                municipality: "",
                district: "",
                property_type: "",
                status: "",
                property_for: "",
                filter_beds: "",
                filter_baths: "",
                page: {
                    ...state.page,
                    currentPage: 1,
                },
            };
        },
    },
});
export const discoverAction = discoverSlice.actions;
export const {
    setPage,
    setFilter,
    resetFilter,
    setActiveTab,
    mapViewChanged,
    setDiscoverData,
    toggleDiscoverModal,
    filterForClusterData,
    handleDiscoverLoading,
    resetSearchFilter,
    status,
} = discoverSlice.actions;
export default discoverSlice;
